<template>
  <div class="global-search-container">
    <div class="global-search-input" :class="focus ? 'expanded' : 'regular'">
      <mf-search
        id="global-search-input"
        v-model="searchValue"
        hide-details
        dense
        placeholder="Buscar páginas..."
        color="cinza-d20"
        :background-color="focus ? 'white' : 'marca-0-d10'"
        :use-clear="focus"
        @keyup="handleSearch"
        @focus="handleFocus"
        @blur="handleBlur"
      />
    </div>
    <Transition>
      <div v-if="focus" class="global-search-content">
        <div v-if="showSuggestions" class="content-recent-searches">
          <span class="content-title">Sugestões de busca</span>
          <div v-for="item in newsSuggestions" :key="item.key" class="clickable" @click="redirectItem(item.route)">
            <global-search-item :item="item" show-prefix :is-new="isNew(item.route).response" />
          </div>
          <div v-for="item in suggestions" :key="item.key" class="clickable" @click="redirectItem(item.route)">
            <global-search-item :item="item" show-prefix />
          </div>
        </div>
        <div v-if="showRecentSearch && computedRecentSearches.length" class="content-recent-searches">
          <span class="content-title">Buscas recentes</span>
          <div v-for="item in computedRecentSearches" :key="item.key" class="clickable" @click="redirectItem(item.route)">
            <global-search-item :item="item" show-prefix />
          </div>
        </div>
        <div v-else-if="searchValue && searchValue.length > 0 && !isEmpty" class="content-search-results" :style="{ gap: showRecentSearch ? '4px' : '10px' }">
          <span class="content-title">Páginas</span>
          <div v-for="item in computedResults" :key="item.name" class="result-item">
            <div class="result-item-title">
              <img v-if="item.icon === 'maria'" :src="require('@/assets/icons/icon-maria-outlined.svg')" alt="maria" />
              <mf-icon v-else size="20" color="marca-0-l10">{{ item.icon }}</mf-icon>
              <span v-html="item.name"></span>
            </div>
            <div v-for="page in item.pages" :key="page.page" class="clickable" @click="redirectItem(page.route)">
              <global-search-item :item="page" />
            </div>
          </div>
        </div>
        <div v-else-if="isEmpty" class="content-empty">
          <div class="icon-section"><mf-icon color="cinza-l10"> scan_delete </mf-icon></div>
          <span>Nenhuma página encontrada</span>
        </div>
      </div>
    </Transition>
  </div>
</template>
<script>
import { isNew } from '@/helpers/news.js'
import { searchModules, getPagePermissions, search, diacriticSpaceSensitiveRegex } from '@/helpers/search.js'
import GlobalSearchItem from './GlobalSearchItem.vue'

export default {
  name: 'GlobalSearch',
  components: {
    GlobalSearchItem,
  },
  props: {},
  data: () => ({
    focus: false,
    searchValue: '',
    results: [],
    recentSearches: [],
    searchSuggestionsRoutes: [
      '/campanhas/cupom-desconto',
      '/clientes/classificacao-rfv',
      '/campanhas/email',
      '/maria/quando-vou-vender',
      '/maria/campanha-da-maria',
      '/maria/produtos-impulsionadores',
    ],
    searchSuggestionsRoutesMercapromo: ['/industria/resultados-gerais', '/industria/ofertas-trade', '/industria/sms-trade'],
  }),
  computed: {
    showRecentSearch() {
      return this.focus && !this.searchValue
    },
    modules() {
      return searchModules
    },
    isEmpty() {
      return this.computedResults?.length === 0 && this.searchValue?.length > 1
    },
    isFranchise() {
      return this.$getLoggedUser().is_franchise
    },
    isFranchisee() {
      return this.$getLoggedUser().is_franchisee
    },
    onlyMercapromo() {
      return this.$getLoggedUser().only_mercapromo
    },
    showSuggestions() {
      return (this.suggestions.length > 0 || this.newsSuggestions.length > 0) && this.searchValue?.length === 0
    },
    newsSuggestions() {
      const modules = this.modules
      const keys = Object.keys(modules)
      const suggestions = []
      keys.forEach((key) => {
        const filter = modules[key].pages.filter((page) => {
          const permissions = getPagePermissions(page, this.$permissions, this.$getAllowedModules)
          return this.isNew(page.route).response && permissions
        })
        if (filter.length) {
          filter.map((page) => {
            suggestions.push({ key, route: page.route })
          })
        }
      })
      return suggestions.map((item) => this.findItem(item.key, item.route))
    },
    suggestions() {
      if (this.computedRecentSearches?.length < 3 && !this.isEmpty && !this.searchValue) {
        const modules = this.modules
        const keys = Object.keys(modules)
        const suggestions = []
        keys.forEach((key) => {
          const filter = modules[key].pages.filter((page) => {
            const permissions = getPagePermissions(page, this.$permissions, this.$getAllowedModules)
            if (this.onlyMercapromo) {
              return this.searchSuggestionsRoutesMercapromo.includes(page.route) && permissions
            } else {
              return this.searchSuggestionsRoutes.includes(page.route) && permissions
            }
          })
          if (filter.length) {
            filter.map((page) => {
              suggestions.push({ key, route: page.route })
            })
          }
        })
        return suggestions.map((item) => this.findItem(item.key, item.route))
      } else return []
    },
    computedResults: {
      get() {
        return this.searchValue?.length > 0 ? this.results.filter((result) => result.pages.length > 0) : []
      },
      set(value) {
        const searchRegex = diacriticSpaceSensitiveRegex(this.searchValue)
        this.results = value.map((module) => {
          module.name = module.name.replace(searchRegex, (match) => {
            return '<span class="highlight">' + match + '</span>'
          })
          module.pages.map((page) => {
            page.page = page.page.replace(searchRegex, (match) => {
              return '<span class="highlight">' + match + '</span>'
            })
            page.description = page.description.replace(searchRegex, (match) => {
              return '<span class="highlight">' + match + '</span>'
            })
            return page
          })
          return module
        })
      },
    },
    computedRecentSearches: {
      get() {
        const modules = this.modules
        const keys = Object.keys(modules)
        const routes = []
        keys.map((key) => {
          let pages = modules[key].pages
          const verifyOnlyMercapromo = modules[key].onlyMercapromo ? this.onlyMercapromo : false
          pages = pages.filter((page) => {
            return getPagePermissions(page, this.$permissions, this.$getAllowedModules) && !verifyOnlyMercapromo
          })
          pages.map((page) => {
            routes.push(page.route)
          })
        })
        return this.recentSearches.filter((search) => routes.includes(search.route))
      },
      set(value) {
        window.localStorage.setItem('recent-searches', JSON.stringify(value))
        const recentItems = JSON.parse(window.localStorage.getItem('recent-searches'))
        this.recentSearches = recentItems ? recentItems.map((item) => this.findItem(item.key, item.route)).reverse() : []
      },
    },
  },
  mounted() {
    const localStorageSearches = JSON.parse(window.localStorage.getItem('recent-searches'))
    this.computedRecentSearches = localStorageSearches || []
  },
  methods: {
    search,
    isNew,
    handleFocus() {
      this.focus = true
    },
    handleBlur() {
      this.focus = false
    },
    handleSearch(value) {
      const results = search(value.target.value, this.$permissions, this.$getAllowedModules)
      this.computedResults = results
    },
    findItem(key, route) {
      const item = this.modules[key].pages.filter((page) => page.route === route)
      return {
        name: this.modules[key].name,
        page: item[0].page,
        description: item[0].description,
        route: item[0].route,
      }
    },
    redirectItem(route) {
      let item
      const modules = this.modules
      const keys = Object.keys(modules)
      keys.forEach((key) => {
        const filter = modules[key].pages.filter((page) => page.route === route)
        if (filter.length) {
          item = { key, route: route }
        }
      })
      let localStorageItems = JSON.parse(window.localStorage.getItem('recent-searches'))
      if (localStorageItems) {
        const indexOf = localStorageItems.findIndex((index) => index.route === item.route)
        if (indexOf !== -1) {
          localStorageItems = localStorageItems.slice(0, indexOf).concat(localStorageItems.slice(indexOf + 1, localStorageItems.length))
        }
        localStorageItems.push(item)
        this.computedRecentSearches = localStorageItems.slice(-5)
      } else {
        this.computedRecentSearches = [item]
      }
      this.focus = false
      this.searchValue = ''
      this.$router.push({ path: route }).catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.global-search-container {
  width: 100%;
  .global-search-input {
    max-height: 100%;
    border-left: 1.5px solid $marca-0-l20;
    padding-left: 16px;
    margin-left: 16px;
    transition: all 0.5s;
  }
  .expanded {
    max-width: 416px;
    ::v-deep .v-input {
      color: $marca-0-l20 !important;
    }
    ::v-deep input {
      color: $cinza-d10 !important;
    }
    ::-webkit-input-placeholder {
      color: $cinza-l60;
    }
  }
  .regular {
    width: 225px;
  }
  .global-search-content {
    position: fixed;
    top: 55px;
    left: 210px;
    width: 400px;
    max-height: 70vh;
    overflow-y: auto;
    border-radius: 8px;
    background-color: white;
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.18);
    padding: 12px;
    letter-spacing: 0.1px;
    line-height: 120%;
    transition: all 0.5s ease-in-out;

    .content-title {
      color: $cinza-0;
      font-size: 12px;
    }
    .content-search-results {
      display: flex;
      flex-direction: column;
      .result-item {
        border: 1px solid $cinza-l70;
        padding: 12px 6px;
        border-radius: 8px;
        .result-item-title {
          img {
            width: 20px;
            height: 20px !important;
          }
          padding: 0px 8px;
          margin-bottom: 5px;
          display: flex;
          flex-direction: row;
          gap: 6px;
          span {
            color: $marca-0-l10;
            font-size: 14px;
            font-weight: 600;
          }
        }
      }
    }
    .content-recent-searches {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
    .content-empty {
      border: 2px dashed $cinza-l70;
      width: 100%;
      height: 134px;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 10px;
      .icon-section {
        margin: 0 auto;
        height: 44px;
        width: 44px;
        border-radius: 22px;
        background-color: $cinza-l90;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      span {
        color: $cinza-l10;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0em;
        text-align: center;
      }
    }
  }
}

.v-leave-active {
  transition: opacity 0.2s ease-in-out;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.clickable {
  cursor: pointer;
  border-radius: 4px;
  :hover {
    background-color: $cinza-l90;
  }
}

::v-deep .highlight {
  background-color: #d9ebfd;
}
</style>
